export class Cookies {
    init()
    {
        var self = this;
        $(document).ready(function ()
        {
            if( self.getCookie('cookie_agree') != 1 )
            {
                $('.cookies-tab').css({opacity:0}).removeClass('d-none').animate({opacity:1}, 500);
                $('.cookies-tab .button').click(function ()
                {
                    self.cookieAgree();
                    return false;
                });
            }
        });

    }
    cookieAgree()
    {
        var self = this;
        self.setCookie("cookie_agree", 1, 365);
        $('.cookies-tab').fadeOut(400);
    }
    getCookie(name)
    {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }
    setCookie(name, value, days)
    {
        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }
}